/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_A4Inputs */

const et_faq_a4 = /** @type {(inputs: Faq_A4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Koduleht muutub müügimasinaks siis, kui see teeb kolm asja hästi: tõmbab õige inimese lehele, eemaldab tema ostuhirmud ja teeb päringu saatmise lihtsaks. Selleks on vaja SEO-d, tugevat pakkumist, selgeid CTA-nuppe, usaldust loovaid tõendeid ja automaatikat. ScalingWebs aitab ehitada süsteemi, kus koduleht ei piirdu info näitamisega. See kogub päringuid, kvalifitseerib huvilisi, suunab nad CRM-i ja aitab müügiprotsessi kiirendada ka väljaspool tööaega.`)
};

const en_faq_a4 = /** @type {(inputs: Faq_A4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A website becomes a sales machine when it does three things well: attracts the right visitor, removes purchase hesitation, and makes sending an inquiry easy. That requires SEO, a strong offer, clear CTA buttons, trust-building proof, and automation. ScalingWebs helps build a system where your website does more than display information. It captures inquiries, qualifies leads, routes them into your CRM, and helps accelerate the sales process even outside business hours.`)
};

/**
* | output |
* | --- |
* | "A website becomes a sales machine when it does three things well: attracts the right visitor, removes purchase hesitation, and makes sending an inquiry easy...." |
*
* @param {Faq_A4Inputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const faq_a4 = /** @type {((inputs?: Faq_A4Inputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_A4Inputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_faq_a4(inputs)
	return en_faq_a4(inputs)
});